import { createReducer, Action, on } from '@ngrx/store';

import { SizeActions } from './size.actions';
import { SizeState } from './size.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: SizeState = {
  sizes: {},
  activePanels: {},
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      SizeActions.SetPageSizes,
      (state, action): SizeState => ({
        ...state,
        sizes: { ...state.sizes, [action.pageId]: action.sizes },
      })
    )
  )
);

export function reducer(state: SizeState | undefined, action: Action) {
  return featureReducer(state, action);
}
